// Faixa para administradores: conexão do WhatsApp Oficial com problema de
// conta na Meta (pagamento pendente, conta restrita...). Fica em fluxo normal
// (não `fixed`), então empilha/quebra em qualquer largura. Nunca bloqueia
// nada. A dispensa vive só no estado do componente (some ao recarregar a página
// enquanto a marca existir) e é chaveada por conexão + accountIssueAt: um
// problema NOVO volta a aparecer. Admin pode zerar a marca em "Já regularizei".
import React, { useState, useCallback } from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import CloseIcon from "@material-ui/icons/Close";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { i18n } from "../../translate/i18n";
import { descreveFalha } from "../../helpers/erroMeta";
import { AEROS, stateText } from "../../styles/aerosTokens";
import BotaoJaRegularizei from "../../components/BotaoJaRegularizei";
import { conexoesComProblemaDeConta, chaveDispensaContaMeta, mostraFaixaContaMeta } from "./headerRules";

const useStyles = makeStyles((theme) => {
  const cor = stateText(theme, AEROS.warning, "warning");
  return {
    root: {
      display: "flex", alignItems: "flex-start", gap: 12, flexWrap: "wrap",
      padding: "10px 16px", boxSizing: "border-box", maxWidth: "100%",
      backgroundColor: alpha(AEROS.warning, theme.palette.type === "light" ? 0.14 : 0.12),
      borderBottom: `1px solid ${alpha(AEROS.warning, 0.35)}`,
      color: theme.palette.text.primary,
    },
    icon: { color: cor, fontSize: 22, flex: "none", marginTop: 2 },
    body: { flex: "1 1 240px", minWidth: 0, display: "flex", flexDirection: "column", gap: 10 },
    item: { display: "flex", flexDirection: "column", gap: 4, minWidth: 0 },
    title: { fontSize: 13.5, fontWeight: 700, color: cor, overflowWrap: "anywhere" },
    text: { fontSize: 13, lineHeight: 1.45, overflowWrap: "anywhere" },
    action: {
      display: "inline-flex", alignItems: "center", gap: 6, alignSelf: "flex-start",
      minHeight: 44, padding: "0 12px", borderRadius: 10, fontSize: 13, fontWeight: 700,
      color: cor, textDecoration: "none", border: `1px solid ${alpha(AEROS.warning, 0.5)}`,
      touchAction: "manipulation",
      "&:hover": { backgroundColor: alpha(AEROS.warning, 0.16) },
      "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
      "& .MuiSvgIcon-root": { fontSize: 16 },
    },
    close: {
      flex: "none", width: 44, height: 44, display: "inline-flex", alignItems: "center", justifyContent: "center",
      borderRadius: 10, border: "none", background: "none", cursor: "pointer", color: theme.palette.text.secondary,
      touchAction: "manipulation", marginLeft: "auto",
      "&:hover": { backgroundColor: theme.palette.action.hover, color: theme.palette.text.primary },
      "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    },
  };
});

const AvisoContaMeta = ({ user, whatsApps }) => {
  const classes = useStyles();
  const [dispensadas, setDispensadas] = useState(() => new Set());

  const dispensar = useCallback((lista) => {
    setDispensadas((prev) => {
      const prox = new Set(prev);
      lista.forEach((w) => prox.add(chaveDispensaContaMeta(w)));
      return prox;
    });
  }, []);

  if (!mostraFaixaContaMeta(user, whatsApps, dispensadas)) return null;
  const visiveis = conexoesComProblemaDeConta(whatsApps).filter((w) => !dispensadas.has(chaveDispensaContaMeta(w)));

  return (
    <div className={classes.root} role="status" aria-live="polite" data-testid="aviso-conta-meta">
      <ReportProblemOutlinedIcon className={classes.icon} aria-hidden="true" />
      <div className={classes.body}>
        {visiveis.map((w) => {
          const d = descreveFalha({ failureCode: w.accountIssueCode, failureReason: w.accountIssueReason, failureLink: w.accountIssueLink });
          return (
            <div key={w.id} className={classes.item}>
              <div className={classes.title}>{i18n.t("metaErrors.bannerTitle")} · {w.name}</div>
              <div className={classes.text}>{d.titulo}</div>
              {d.acao ? <div className={classes.text}>{d.acao}</div> : null}
              {d.link ? (
                <a className={classes.action} href={d.link} target="_blank" rel="noopener noreferrer">
                  {i18n.t("metaErrors.fixAt")}
                  <OpenInNewIcon aria-hidden="true" />
                </a>
              ) : null}
              <BotaoJaRegularizei whatsappId={w.id} user={user} />
            </div>
          );
        })}
      </div>
      <button type="button" className={classes.close} aria-label={i18n.t("metaErrors.bannerDismiss")} onClick={() => dispensar(visiveis)}>
        <CloseIcon fontSize="small" aria-hidden="true" />
      </button>
    </div>
  );
};

export default AvisoContaMeta;
